import { LitElement, html, css, PropertyValues } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import './vxc_valuebox'

interface IDataItem {
    title: string
    value: number|string 
    unit : string
    icon?: string
}

@customElement('vxc-valuelist')
export class TValueList extends LitElement {

    @property({ type: Array , attribute: 'items'  }) items: IDataItem[] = [];
    @property({ type: String, attribute: 'source' 	 }) source: string = '';

    private  abortController: AbortController | null = null;

    static styles = css`
        :host {
            display: block;
            box-sizing: border-box;
        }

        .container {
            display: flex;
            flex-wrap: wrap; /* Allows panels to wrap if there's not enough space */
            gap: 1rem; /* Space between panels */
            padding: 1rem;
        }

        .panel {
            flex: 1 1 calc(20% - 1rem); /* Makes each panel take up 1/3 of the width */
            box-sizing: border-box;
            xmin-width: 5rem; /* Ensures panels don't become too small */
        }
   `;

    // firstUpdated() {
    //     this.items = [ 
    //         { title: 'Nombre de sessions', value: 12564, unit: 'sessions' },
    //         { title: 'Nombre de questions', value: 21904, unit: 'questions' },
    //         { title: 'Nombre de pouces', value: 450, unit: 'évaluations'}
    //     ]
    // }
    
    private cancelCurrentFetch() {
        if (this.abortController) {
            this.abortController.abort();
            this.abortController = null;
        }
    }

    disconnectedCallback() {
        super.disconnectedCallback()
        this.cancelCurrentFetch()
    }

    updated(changedProperties: PropertyValues) {
        super.updated(changedProperties);

        if (changedProperties.has('source') && this.source) {
            this.fetchData();
        }
    }

    private async fetchData() {
        console.log('fetchData()', this.source)
        if (!this.source?.length) return;
  
        // Cancel any ongoing fetch before starting a new one
        this.cancelCurrentFetch();
  
        // Create new AbortController for this fetch
        this.abortController = new AbortController();
  
        try {
            const response = await fetch(this.source, {
                signal: this.abortController.signal,
                headers: {
                    'x-api-key': 'api_key',
                    'Content-Type': 'application/json',
                }
            });
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const jsonData = await response.json();
            console.log('fetch returned :', jsonData)
            this.items = jsonData || []            
        } 
        catch (e) { 
            console.error((e as Error).name, (e as Error).message) 
        }
        finally {
            if (this.abortController) {  // Only update loading state if not aborted
                this.abortController = null;
            }
        }
    }

    render() {
        console.log('valuebox', this.items)
        return html`
            <div class="container">
                ${this.items.map( item => html`
                <div class="panel">
                    <vxc-valuebox
                        title=${item.title}
                        value=${item.value}
                        unit=${item.unit}
                        icon=${item.icon}
                    ></vxc-valuebox>
                </div>`) }
            </div>`
    }
}

declare global {
  interface HTMLElementTagNameMap {
    'vxc-valuelist': TValueList;
  }
}